
<template>
  <div>
  <div class="cntnt" >

<div id="terms">

    <h1 class="heading">  Website Terms & Conditions</h1>
    <p class="content">
      The official website of Assam Power Distribution Company Limited (APDCL) has been developed and hosted to provide information to the general public. The documents and information displayed in this website are for reference purposes only and does not purport to be a legal document.
  <br><br>
  Though all efforts have been made to ensure the accuracy of the content on this website, the same should not be construed as a statement of law or used for any legal purposes. In case of any ambiguity or doubts, users are advised to verify/check with the company and/or other sources wherever applicable so as to obtain appropriate information.
  <br><br>
  In case of any variance between what has been stated in the website and that contained in the relevant Acts, Rules, Regulations, Policy Statements etc., the latter shall prevail.
  <br><br>
  Any specific advice or replies to any query or set of queries in any part of the website is/are the personal views/opinion of such experts/consultants/persons and are not necessarily subscribed to by the Company or its website.
  <br><br>
  Certain links on the website, placed for the convenience of visitors, leads to resources located on other websites maintained by third parties over whom APDCL has no control. These websites are external to APDCL. APDCL neither endorses in any way nor offers any judgment or warranty and accepts no responsibility or liability for the authenticity, availability of any of the goods or services or for any damage, loss or harm, direct or consequential or for any violation of local or international laws that may result or may be incurred while visiting or transacting on these external websites.
    </p>
  </div>
<br><br><br><br><br><br><br><br><br><br>
<div id="privacy">
  <b-row>
    <b-col cols="6">
        <h1 class="heading">Privacy Policy</h1>
    </b-col>
</b-row>
<p class="content">
  Assam Power Distribution Company Limited (APDCL) respects and protects the privacy of the individuals/Consumers who use our Website/online services/mobile apps and whose revenue bills/service connections are processed with our software applications/mobile apps.
  <br><br>
  Individually identifiable information about you is not wilfully disclosed to any third party without first receiving your permission, as explained in this privacy policy ("Privacy Policy"). Most browsers are initially set up to accept cookies. You can reset your browser to refuse all cookies or to indicate when a cookie is being sent. Be aware, however, that some parts of our services may not function properly if you refuse cookies.
  <br><br>
  Except when you specifically and knowingly provide such information, we do not collect any unique information about you (such as your name, email address, Mobile No etc.). We however may collect the GPS co-ordinates of your premises for providing swift fuse call services.
  <br><br>
  By agreeing to use this website, you also agree to receive Email/SMS communication from APDCL in connection with your consumer number or other general consumer information/announcements from APDCL. APDCL will not share your personal data with advertisers, sponsors, and other third parties without your express consent. Please be aware, however, that we will release specific personal information about you if required to do so in order to comply with any valid legal process such as a search warrant, court order etc.
  <br><br>
  By using www.apdcl.org and by availing our e-services, you consent to the collection and use of your information as we have outlined in this policy and to our Terms & Conditions. APDCL may decide to change this Privacy Policy from time to time. When we do, we will post those changes on this page so that you are always aware of the information we collect, how we use it, and under what circumstances we disclose it.
</p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="copyright">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">Copyright Policy</h1>
    </b-col>

 </b-row>

<p class="content">
Materials that feature on this website are in the public domain and as such may be reproduced in any format or media without alteration and shall not require any specific permission. This is subject to the condition that the materials be reproduced accurately and not in any derogatory manner or in a misleading context. Where the material is being published or issued to others, the source must be prominently acknowledged. The permission to reproduce material excludes any material on this site that may/shall amount to infringement of copyright of a third party. Authorisation to reproduce such material must be obtained beforehand from the copyright holders concerned.
</p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="hyperlink">
  <b-row>
    <b-col cols="6">
    <h1 class="heading">Hyperlink Policy</h1>
    </b-col>

 </b-row>

 <p class="content">
   As a matter of policy we have no objection to any direct linking to the information that is hosted on our site and no prior permission is required for the same. However we would like to be informed about any links provided to our site to facilitate updations therein in respect of changes or otherwise wherever required. Also, we do not permit our pages to be directly loaded into frames on another site. Our Company's page/pages must land/load onto a new browser window of the user by default.
   <br><br>
   At many places in this portal, visitors may find links to other websites/portal, these links have been placed for their convenience. APDCL is not responsible for the contents and reliability of these linked websites/portals and does not necessarily endorse the views expressed therein. Mere presence of the link(s) or its listing on this portal should not be assumed as endorsement of any kind. We cannot guarantee that these links will work all the time as we have no control over availability of such links. It would be highly appreciated if information about any such any such dead link(s)/broken link(s) are brought to our notice so as to enable us to take appropriate action.
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br>
<div id="disclaimer">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">Disclaimer</h1>
    </b-col>

 </b-row>
 <p class="content">
   While every care has been taken to ensure the accuracy of information furnished in this website, APDCL does not accept any responsibility or liability for any damage or loss to any person for the result of any action taken on the basis of these information. However, APDCL shall be obliged if errors/omissions are brought to its notice for carrying out corrections in the next update.

 When users follow a link to an outside website, they are leaving APDCL site and are subject to the privacy and security policies of the outside website.
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br>

</div>
</div>
</template>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.8rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}
#vision{
  transition: 1s;
}
table{
  text-align: left !important;
}
</style>
<script>
export default {
data() {
  return {
    KeyOfficial: [
      { Name: 'Shri Vinod Kumar Pipersenia, IAS (Retd.)', Designation: 'Chairman, APDCL	', Phone: '0361-2739528(O), 0361-2739527 (F)', Mobile: 'NA', Email: 'asebchairman@gmail.com'},
      { Name: 'Shri Niraj Verma, IAS', Designation: 'Principal Secretary, Power(E)', Phone: 'NA', Mobile: 'NA', Email: 'NA'},
      { Name: 'Shri Rakesh Agarwala, IAS', Designation: 'Managing Director, APDCL', Phone: '0361-2739516 (O)', Mobile: 'NA', Email: 'md.apdcl@apdcl.org'},
      { Name: 'Shri Abhijit Sarma Barua	', Designation: 'CGM (CR)', Phone: '	0361-2739521 (O)', Mobile: '9864102725', Email: 'cgm.crapdcl@gmail.com'},
      { Name: 'Shri Dipak Kr. Sarmah', Designation: 'CGM (D&S), LAR', Phone: '0361-2739509 (O)', Mobile: '9435396852', Email: 'cgmlarapdcl@gmail.com'},
      { Name: 'Shri Krishnananda Saikia	', Designation: 'CGM (D&S), CAR	', Phone: '0361-2739512 (O),0361-2739539 (F)', Mobile: '9954071956', Email: 'cgmdapdclcaz@yahoo.com'},
      { Name: 'Shri Dipankar Nath', Designation: 'CGM (D&S), UAR', Phone: '0361-2739532 (O)', Mobile: '9435170970', Email: 'chiefengineer_uaedcl@yahoo.com'},
      { Name: 'Shri Dhrubajyoti Hazarika', Designation: 'CGM (RE)', Phone: '0361-2735684 (O), 0361-2739626 (F)', Mobile: '9101806117', Email: 'cgmre.aseb@gmail.com'},
      { Name: 'Shri Nirmaljit Das	', Designation: 'CGM (PP&D)	', Phone: '0361-2739514 (O)', Mobile: '9435114066', Email: 'cgmppdapdcl@yahoo.com'},
      { Name: 'Shri Manoranjan Kalita	', Designation: 'CGM (Com. & E.E.)	', Phone: '0361-2739515 (O)	', Mobile: '9435137602	', Email: 'acecomt.aseb@gmail.com'},
      { Name: 'Shri Biswajit Kar	', Designation: 'CGM (HRA)	', Phone: '0361-2739507 (O)	', Mobile: 'NA', Email: 'cgmhraapdcl@yahoo.com'},
      { Name: 'Shri Manish Dasgupta	', Designation: 'CGM (F&A)	', Phone: '0361-2739511 (O)	', Mobile: '9864208641', Email: 'fin.apdcl2009@gmail.com, cgmf.apdcl2012@gmail.com'},
      { Name: 'Shri Deepak Kr. Das	', Designation: 'Director (PMU)	', Phone: '0361-2607533 (O)	', Mobile: '9864064649', Email: 'pmu_aseb@rediffmail.com'}
    ],

    ZoneContact: [
      { Name: 'Guwahati Zone', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia Zone', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'},
      { Name: 'Bongaigaon Zone', Contact_Person: 'Shri Jibeswar Das',  Mobile: '9435121248', Email: 'gm.bongaigaon@gmail.com'},
      { Name: 'Tezpur Zone', Contact_Person: 'Shri Bhaskar Jyoti Bora',  Mobile: '7086017970', Email: 'gm.naz@apdcl.org,gmnaztez@gmail.com'},
      { Name: 'Nagaon Zone', Contact_Person: 'Shri Dhruba Bora',  Mobile: '7002899369', Email: 'gmnezapdcl@gmail.com'},
      { Name: 'Silchar Zone', Contact_Person: 'Shri Krishnendu Nath',  Mobile: '9435073549', Email: 'gm.bvz@apdcl.org,gmsz.apdcl@gmail.com'},
      { Name: 'Dibrugarh Zone', Contact_Person: 'Shri Anirban Roy',  Mobile: '9435301799', Email: 'gmdbrapdcl@gmail.com'},
      { Name: 'Jorhat Zone', Contact_Person: 'Shri Debajyoti Das',  Mobile: '9864035124', Email: 'gm.uaz@apdcl.org,gmuaedcl@yahoo.co.in'}
    ],
    CircleContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    DivisionContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    SubContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    IRCAContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ],
    TCContact: [
      { Name: 'Guwahati ', Contact_Person: 'Shri Partha Pratim Sarmah		',  Mobile: '9864050777', Email: 'gm.laz@apdcl.org,gm_gz@rediffmail.com'},
      { Name: 'Rangia ', Contact_Person: 'Smt. Nafiza Borbora	',  Mobile: '9435009537', Email: 'gmrangiazone@gmail.com'}
    ]


  }
}
}
</script>
